import { memo } from 'react';
import type { Ref } from 'react';
import {
   ChakraSVGCircle,
   ChakraSVGGroup,
   ChakraSVGCircleProps,
   ChakraSVGGroupProps,
} from './styleableSvgComponents';

// Forwarded for tippy:
// https://github.com/atomiks/tippy.js-react#component-children
export const BasicHotspot = memo(function BasicHotspot({
   ref,
   x,
   y,
   innerCircleProps,
   outerCircleProps,
   groupProps,
}: {
   x: number;
   y: number;
   innerCircleProps?: ChakraSVGCircleProps;
   outerCircleProps?: ChakraSVGCircleProps;
   groupProps?: ChakraSVGGroupProps;
   ref?: Ref<SVGGElement>;
}) {
   return (
      <ChakraSVGGroup ref={ref} {...groupProps}>
         <ChakraSVGCircle x={x} y={y} r={18} {...outerCircleProps} />
         <ChakraSVGCircle x={x} y={y} r={6} {...innerCircleProps} />
      </ChakraSVGGroup>
   );
});
